import { Button } from "../atoms/Button.tsx";

interface Props {
  submitting: boolean;
  editing: boolean;
  onCancel: () => void;
}

export function FormActions({ submitting, editing, onCancel }: Props) {
  return (
    <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 8 }}>
      <Button type="button" onClick={onCancel} disabled={submitting}>
        Cancel
      </Button>
      <Button type="submit" variant="primary" disabled={submitting}>
        {submitting ? "Saving…" : editing ? "Save changes" : "Create"}
      </Button>
    </div>
  );
}
